import React, { useState, useEffect } from 'react';
import { useStripe, useElements, CardElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import productImg from "../assets/product/solidchaim.png";
import CartServices from '../services/API/CartService';
import { Link, useNavigate } from 'react-router-dom';
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useLoadScript } from "@react-google-maps/api";
import { MdShoppingCart } from 'react-icons/md';
import { FaArrowRight } from 'react-icons/fa';

const libraries = ["places"]; // Load only the 'places' library

// Load your Stripe publishable key
const stripePromise = loadStripe('pk_test_51HiCo6EHLDkHxi1YwwTc185yQTBuRIZktAiqLEus7vFq1kKxsrir4UlAUVCP6rRokopLAFCYY1DKowhrjZuLhyv200gfW8PqZc');

const CheckoutForm = ({ cartProductsTotal, userId }) => {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [postalCode, setPostalCode] = useState('');
      const [country, setCountry] = useState("");
    
    const [phoneNo, setPhoneNo] = useState('');

     const { isLoaded } = useLoadScript({
        googleMapsApiKey: 'AIzaSyDg6Ci3L6yS5YvtKAkWQjnodGUtlNYHw9Y', // Secure API Key
        libraries,
      });

        // Function to handle address selection
        const handleAddressSelect = async (place) => {
          setAddress(place.label);
        
          const placeId = place.value.place_id;
          const geocoder = new window.google.maps.Geocoder();
        
          geocoder.geocode({ placeId }, (results, status) => {
            if (status === "OK" && results[0]) {
              const addressComponents = results[0].address_components;
        
              let cityName = "";
              let postalCodeValue = "";
              let countryCode = ""; // Use ISO 3166-1 alpha-2 code
        
              addressComponents.forEach((component) => {
                if (component.types.includes("locality")) {
                  cityName = component.long_name;
                }
                if (component.types.includes("postal_code")) {
                  postalCodeValue = component.long_name;
                }
                if (component.types.includes("country")) {
                  countryCode = component.short_name; // This ensures you get "US" instead of "United States"
                }
              });
        
              setCity(cityName);
              setPostalCode(postalCodeValue);
              setCountry(countryCode); // Use the country code here
            }
          });
        };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const cardElement = elements.getElement(CardElement);

        // Create a payment method
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                email,
                name: `${firstName} ${lastName}`,
                address: {
                    line1: address,
                    city,
                    postal_code: postalCode,
                },
                phone: phoneNo,
            },
        });

        if (error) {
            console.error(error);
        } else {
            // Send the payment method ID and order details to your backend
            const response = await axios.post('https://jewellery.testingwebsitelink.com/api/cart/checkout', {
                user_id: userId,
                first_name: firstName,
                last_name: lastName,
                address,
                city,
                country,
                postal_code: postalCode.replace(/\D/g, "") || "00000",
                phone_no: phoneNo,
                email,
                pm_card_Id: paymentMethod.id,
            });

            if (response.data.status) {
                navigate("/");
                console.log("Payment successful and order placed:", response.data);
                // Handle successful payment and order placement
            } else {
                console.error("Payment or order placement failed:", response.data);
                // Handle failed payment or order placement
            }
        }
    };
    const cardElementOptions = {
        style: {
            base: {
                fontSize: '16px',
                color: '#424770',
                letterSpacing: '0.025em',
                fontFamily: 'Source Code Pro, monospace',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
    
    return (
        <Form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg p-6 space-y-4">
      {/* CONTACT SECTION */}
      <div>
        <h6 className="text-lg font-semibold text-gray-700">CONTACT</h6>
        <Form.Control
          type="email"
          placeholder="EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* DELIVERY SECTION */}
      <div>
        <h6 className="text-lg font-semibold text-gray-700">DELIVERY</h6>
        {isLoaded ? (
          <GooglePlacesAutocomplete
            selectProps={{
              onChange: handleAddressSelect,
              placeholder: "Enter Address",
            }}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        ) : (
          <p>Loading...</p>
        )}
      </div>

      {/* AUTO-FILLED LOCATION FIELDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <input
          type="text"
          placeholder="CITY"
          value={city}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
        <input
          type="text"
          placeholder="POSTAL CODE"
          value={postalCode}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
        <input
          type="text"
          placeholder="COUNTRY"
          value={country}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
      </div>

      {/* Name Inputs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Form.Control
          type="text"
          name="fname"
          placeholder="FIRST NAME"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <Form.Control
          type="text"
          name="lname"
          placeholder="LAST NAME"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      

      {/* Phone */}
      <Form.Control
        type="number"
        name="phone"
        placeholder="PHONE"
        value={phoneNo}
        onChange={(e) => setPhoneNo(e.target.value)}
        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {/* PAYMENT SECTION */}
      <div>
        <h6 className="text-lg font-semibold text-gray-700">PAYMENT</h6>
        <CardElement options={cardElementOptions} className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>

      {/* Checkbox */}
      <div className="flex items-center gap-2">
        <Form.Check type="checkbox" />
        <span className="text-sm text-gray-700">Email Me With News And Offers</span>
      </div>

      {/* Terms & Conditions */}
      <p className="text-xs text-gray-600 leading-5">
        By clicking below and completing your order, you agree to purchase your item(s) from Global-e as merchant of record for this transaction, on Global-e's
        <a href="#" className="text-blue-500 underline"> Terms and Conditions</a> and
        <a href="#" className="text-blue-500 underline"> Privacy Policy</a>.
      </p>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={!stripe || !elements}
        className="w-full bg-[#F4CF38] text-black font-semibold py-3 rounded-lg  transition duration-300 disabled:bg-gray-400"
      >
        Pay Now
      </button>
    </Form>
    );
};

const Main = () => {
    const [cartProducts, setCartProducts] = useState([]);
    const [cartProductsTotal, setCartProductsTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const userId = sessionStorage.getItem("userId") || sessionStorage.getItem("randomUserId");

    const getCartData = async (userId) => {
        try {
            const res = await CartServices.getCart(userId);
            if (res.status) {
                const products = res.data.order;
                setCartProducts(products);
                setCartProductsTotal(res.data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error fetching cart data:", error);
        }
    };

    useEffect(() => {
        getCartData(userId);
    }, [userId]);
    if (isLoading) {
        return (
          <div className="flex justify-center items-center py-16 bg-[#fff]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#F4CF38]"></div>
      </div>
        );
      }
          if (cartProducts.length === 0) {
              return (
                  <div className="flex flex-col items-center justify-center h-screen text-center px-4">
                      <MdShoppingCart className="text-6xl text-gray-400" />
                      <h2 className="text-2xl font-semibold mt-4">Your cart is empty</h2>
                      <p className="text-gray-500 mt-2">Looks like you haven't added anything to your cart yet.</p>
                      <Link to="/" className="mt-5">
                          <button className="px-6 py-3 bg-[#F4CF38] text-black font-bold rounded-lg transition flex align-items-center gap-2 m-0">
                              Continue Shopping <FaArrowRight/>
                          </button>
                      </Link>
                  </div>
              );
          }
    return (
        <>
            <div className="container mx-auto p-6 text-left">
            <h2 className="text-3xl font-bold text-center mb-8">CHECKOUT</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Left Section - Checkout Form */}
                {/* <div className="bg-white p-6 shadow-lg rounded-lg"> */}
                    <Elements stripe={stripePromise}>
                        <CheckoutForm cartProductsTotal={cartProductsTotal} userId={userId} />
                    </Elements>
                {/* </div> */}

                {/* Right Section - Cart Summary */}
                <div className="bg-gray-100 p-6 shadow-lg rounded-lg">
                    <h3 className="text-xl font-semibold mb-4">Your Order</h3>
                    <div className="space-y-4">
                        {cartProducts.map(cartItem => (
                            <div key={cartItem.id} className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
                                <div className="flex items-center space-x-4">
                                    <img src={cartItem.products.productImage} alt={cartItem.products.name} className="w-16 h-16 object-cover rounded-lg" />
                                    <span className="text-lg font-semibold">{cartItem.products.name}</span>
                                </div>
                                <span className="text-lg font-bold">${cartItem.products.price}</span>
                            </div>
                        ))}
                    </div>

                    {/* Price Summary */}
                    <div className="mt-6 p-4 bg-white rounded-lg shadow">
                        <div className="flex justify-between text-lg">
                            <span className="text-gray-600">Discount</span>
                            <span className="text-red-500">${cartProductsTotal.discount}</span>
                        </div>
                        <div className="flex justify-between text-lg mt-2">
                            <span className="text-gray-600">Shipping</span>
                            <span className="text-gray-600">${cartProductsTotal.shipping}</span>
                        </div>
                        <div className="flex justify-between text-xl font-bold mt-4 border-t pt-2">
                            <span>Subtotal</span>
                            <span>${cartProductsTotal.total}</span>
                        </div>
                    </div>

                    {/* Discount Input */}
                    {/* <div className="mt-6 flex items-center space-x-2">
                        <Form.Control 
                            type="text" 
                            placeholder="Apply discount" 
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />
                        <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">Apply</button>
                    </div> */}
                </div>
            </div>
        </div>
        </>
    );
};

export default Main;
